import { getDashboardAverageHandledTime } from '../../utils/awsAPI';
import { useEffect, useState } from "react";
import { secondsToHMS } from '../../utils/utils';
import { useSelector } from 'react-redux';

const getCurrentTime = () => {
    const today = new Date();
    
    let hoursNum = today.getHours();
    let hoursStr = hoursNum.toString();

    let minNum = today.getMinutes();
    let minStr = minNum.toString();

    let secNum = today.getSeconds();
    let secStr = secNum.toString();

    if (hoursNum < 10) hoursStr = '0' + hoursStr;
    if (minNum < 10) minStr = '0' + minStr;
    if (secNum < 10) secStr = '0' + secStr;
    
    return `${hoursStr}:${minStr}:${secStr}`;
};

const AverageHandledTime = () => {
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const [averageVoiceHandledTime, setAverageVoiceHandledTime] = useState(0)
    const [averageChatHandledTime, setAverageChatHandledTime] = useState(0)
    const [timeFrame, setTimeFrame] = useState({'text': 'Today', 'value':'0d', 'localTime':getCurrentTime()});
    const [chartData, setChartData] = useState<any>([
        {voice:{"channel":"Voice", "initial": 10, "remaining": 0}},
        {chat:{"channel":"Chat", "initial": 10, "remaining": 0}}
    ])

    useEffect(()=>{
        const getDashboardData = async () => {
            let agentUsername = (agentObj) ? agentObj.getConfiguration().username:""; 
            const agentStatisticsResponse = await getDashboardAverageHandledTime(agentUsername, timeFrame.value, timeFrame.localTime);
            let voiceHandledTime = (agentStatisticsResponse.voice.AvgHandleTime.value)?agentStatisticsResponse.voice.AvgHandleTime.value:0
            setAverageVoiceHandledTime(voiceHandledTime)
            let chatHandledTime = (agentStatisticsResponse.chat.AvgHandleTime.value)?agentStatisticsResponse.chat.AvgHandleTime.value:0
            setAverageChatHandledTime(chatHandledTime);
            setChartData([
                {voice:{"channel": "Voice", "initial": 10, "remaining": parseFloat((voiceHandledTime/60).toFixed(1))}},
                {chat:{"channel": "Chat", "initial": 10, "remaining": parseFloat((chatHandledTime/60).toFixed(1))}}
            ])
        }
        getDashboardData();
    },[timeFrame.value, agentObj])

    const onSelectTimeFrame = (event:any,selectedTimeFrame:string,userLocalTime:any) => {
        setTimeFrame({'text': event.target.value, 'value':selectedTimeFrame, 'localTime':userLocalTime})
    }
    
    const SemiCircleChart = () => {
        return (
            <div className="card contact-sattistcs collapse show mt-3" id="agent_handledtime">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Average handled time - agent</h6>
                    <div className='d-flex'>
                        <div className="dropdown">
                            <button type="button" className={`btn btn-sm dropdown-toggle`} data-bs-toggle="dropdown">
                                {timeFrame.text}
                            </button>
                            <ul className="dropdown-menu">
                                <li>
                                    <button onClick={ (event)=>{onSelectTimeFrame(event,'0d',getCurrentTime())} } value="Today" className="dropdown-item">Today</button>
                                    <button onClick={ (event)=>{onSelectTimeFrame(event,'1d',getCurrentTime())} } value="1 Day" className="dropdown-item">1 day</button>
                                    <button onClick={ (event)=>{onSelectTimeFrame(event,'1w',getCurrentTime())} } value="1 Week" className="dropdown-item">1 week</button>
                                    <button onClick={ (event)=>{onSelectTimeFrame(event,'1M',getCurrentTime())} } value="1 Month" className="dropdown-item">1 month</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="card-body height-200">
                    <div className="row">
                        <div className="col-6">
                            <div className="sc-gauge">
                                <div className="sc-background">
                                    <div className="sc-percentage" style={{ transform: `rotate(${(chartData[0].voice.remaining / chartData[0].voice.initial) * 180}deg)` }}></div>
                                    <div className="sc-mask"></div>
                                    <span className="sc-value">{ chartData[0].voice.remaining }</span>
                                </div>
                                <span className="sc-min">{ 0 }</span>
                                <span className="sc-max">{ chartData[0].voice.initial }</span>
                            </div>
                            <div className='text-center'><label>Voice: <span>{secondsToHMS(averageVoiceHandledTime)}</span></label></div>
                        </div>
                        <div className="col-6">
                            <div className="sc-gauge">
                                <div className="sc-background">
                                    <div className="sc-percentage" style={{ transform: `rotate(${(chartData[1].chat.remaining / chartData[1].chat.initial) * 180}deg)` }}></div>
                                    <div className="sc-mask"></div>
                                    <span className="sc-value">{ chartData[1].chat.remaining }</span>
                                </div>
                                <span className="sc-min">{ 0 }</span>
                                <span className="sc-max">{ chartData[1].chat.initial }</span>
                            </div>
                            <div className='text-center'><label>Chats : <span>{secondsToHMS(averageChatHandledTime)}</span></label></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return(
        <SemiCircleChart/>
    )

}
export default AverageHandledTime;